<div class="container sms001">
  <!-- ヘッダーエリア -->
  <app-header></app-header>
  <p class="screen-name-area">
    <label>{{lblScreenName}}</label>
  </p>

  <!-- メインエリア -->
  <div class="main-area">

    <!-- コンテンツエリア -->
    <div class="content-area" [style.width]="windowsWidth">

      <!-- フォームエリア -->
      <form class="sms-form">
        <div [formGroup]="smsForm">

          <!-- 言語プルダウン -->
          <div class="language-area">
            <div class="language">
              <select id="optlanguageType" #language (change)="onChangeLangType(language.value)">
                <option hidden selected>language</option>
                <option *ngFor="let language of langTypeVO" [value]="language.id">
                  {{language.name}}
                </option>
              </select>
            </div>
          </div>
          <br>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage01}}</mat-label>
            <br>
            <mat-label class="message">{{lblMessage02}}</mat-label>
            </div>
          <br>

          <div>
            <mat-label class="message">{{lblMessage03}}</mat-label>
            <mat-radio-group formControlName="rdoMenuShbt" class="radio-line menu-radio-group" tabindex="1">
              <!-- お支払いに関する項目 -->
              <mat-label class="menu-tittle">{{lblMessage04}}</mat-label>
              <div class="item-line"></div>

              <mat-radio-button class="accordion-content"
                                name="rdoMenuShbt"
                                *ngFor="let menu of torihikiMenuVO; let i = index"
                                [checked]="i === 0"
                                [value]="menu.id">
                <mat-label>{{menu.name}}</mat-label>
              </mat-radio-button>
              <br>
              <br>

              <!-- その他 -->
              <details class="accordion" [style.visibility]="sonotaMenuVisibility">
                <summary class="accordion-header">
                  <mat-label class="menu-tittle">{{lblMessage05}}</mat-label>
                  <div class="item-line"></div>
                </summary>

                <mat-radio-button class="accordion-content"
                                  name="rdoMenuShbt"
                                  *ngFor="let menu of sonotaMenuVO"
                                  [value]="menu.id">
                  <mat-label>{{menu.name}}</mat-label>
                </mat-radio-button>
              </details>
            </mat-radio-group>
          </div>
          <br>

          <!-- 文言 -->
          <div>
            <mat-label class="message">{{lblMessage06}}</mat-label>
            <br>
            <mat-label class="message">{{lblMessage07}}</mat-label>
          </div>

          <!-- 生年月日 -->
          <div  class="input-area">
            <mat-label class="message">{{lblMessage08}}</mat-label>
            <mat-form-field appearance="standard" class="input-date-field">
              <mat-label>{{lblMessage09}}</mat-label>
              <input matInput formControlName="txtBirthday" class="input-date-text" inputmode="tel" tabindex="2" maxlength="8" min="17530101" max="99981231" />
              <mat-error *ngIf="smsForm.get('txtBirthday')?.invalid">*</mat-error>
            </mat-form-field>
          </div>

          <!-- ボタン -->
          <div class="button-area">
            <button type="submit" mat-raised-button [disabled]="!isEnableBtnSubmit" (click)="executeClick()" tabindex="3">{{lblSubmit}}</button>
          </div>

        </div>
      </form>

    </div>
  </div>

  <!-- フッターエリア -->
  <div class="footer-area">
    <div class="img-area">
      <img class="img-logo" src="assets/images/footer_ofi_copyright.png" />
    </div>
    <div class="data-operation-button-area">
    </div>
  </div>
</div>
